/* eslint-disable max-len */
import { Plugins } from '@leverege/plugin';
import ExistsComparator from './ExistsComparator.js';
import ExistsComparatorEditor from "./ExistsComparatorEditor.js";
import ExistsComparatorEvaluator from './ExistsComparatorEvaluator.js';
import NotExistsComparator from './NotExistsComparator.js';
import NotExistsComparatorEditor from "./NotExistsComparatorEditor.js";
import NotExistsComparatorEvaluator from './NotExistsComparatorEvaluator.js';
export default {
  install(opts) {
    Plugins.add('AttributeConditionComparator', ExistsComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: ExistsComparator.TYPE,
      editor: ExistsComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: ExistsComparator.TYPE,
      evaluator: ExistsComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', NotExistsComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: NotExistsComparator.TYPE,
      editor: NotExistsComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: NotExistsComparator.TYPE,
      evaluator: NotExistsComparatorEvaluator
    });
  }
};